import { useCallback, useEffect, useState, createRef } from 'react'
import EstimatePeople from 'components/EstimatePeople'
import iconParlament from './images/parlament.svg'
import iconBevoelkerung from './images/bevoelkerung.svg'
import iconParlamentDark from './images/parlament-dark.svg'
import iconBevoelkerungDark from './images/bevoelkerung-dark.svg'
import { useEffectOnce, useLocalStorage } from 'usehooks-ts'
import styled from 'styled-components'

const Comparison = ({
  tenant,
  colorMode,
  data,
  details,
  wording,
}: {
  tenant?: object
  colorMode?: string
  data?: any
  details?: any
  wording?: any
}) => {
  const [seats, setSeats] = useState(
    details[0].parltotal ? parseInt(details[0].parltotal) : 246
  ) // max 246
  const [isMobile, setIsMobile] = useState(false)
  const [userProfile] = useLocalStorage('userProfile', {})

  const toMios = (total: string) => {
    const mios = Math.round((parseInt(total) / 1000000) * 10) / 10
    const replaced = mios.toString().replace('.', ',')
    return replaced.indexOf(',0') > 1 && replaced.slice(-2) === ','
      ? replaced.replace(',0', '')
      : replaced
  }

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Comp>
      <ComparisonWrapper className={isMobile ? 'mobile' : 'desktop'}>
        <div className='head'>
          <img
            src={colorMode === 'dark' ? iconParlamentDark : iconParlament}
            alt='parlament'
          />
          <h4>Parlament</h4>
          <div className='details'>{details[0].parl}</div>
        </div>
        <div className='head'>
          <img
            src={colorMode === 'dark' ? iconBevoelkerungDark : iconBevoelkerung}
            alt='bevoelkerung'
          />
          <h4 className='nomarg'>Bevölkerung</h4>
          <div className='details'>
            {details[0].population + ': '}
            <span>{toMios(details[0].total) + ' Mio.'}</span>
          </div>
        </div>
        {data
          ?.filter((item: any) => 'label' in item)
          ?.map(function (item: any, index: number) {
            let percPar = undefined
            let peoplePar = undefined
            if (item.par.indexOf('%') > 0) {
              percPar = parseFloat(item.par.replace('%', ''))
            } else {
              peoplePar = parseInt(item.par)
              percPar = (parseInt(item.par) / seats) * 100
            }

            let percBev = undefined
            let peopleBev = undefined
            if (item.bev.indexOf('%') > 0) {
              percBev = parseFloat(item.bev.replace('%', ''))
            } else {
              peopleBev = parseInt(item.bev)
              percBev = (parseInt(item.bev) / seats) * 100
            }

            return (
              <>
                {/*
              <div>
                {percPar} | {1000 + percPar}
              </div>
              <div>
                {percBev} | {1000 + percBev}
              </div>
          */}

                {percPar >= 0 && (
                  <EstimatePeople
                    title={item.label}
                    type='parlament'
                    people={peoplePar}
                    percentage={percPar}
                    tenant={tenant}
                    colorMode={colorMode ? colorMode : 'light'}
                    color='#A09C8A'
                    difference={
                      percPar && percBev
                        ? (seats / 100) * (percPar - percBev)
                        : percPar === 0
                        ? (seats / 100) * (percPar - percBev)
                        : undefined
                    }
                    percBev={percBev}
                    percPar={percPar}
                    percDiff={percPar - percBev}
                    seats={seats}
                  />
                )}

                {percBev >= 0 && (
                  <EstimatePeople
                    title={item.label}
                    type='bevoelkerung'
                    population={parseInt(details[0].total)}
                    people={peopleBev}
                    percentage={percBev}
                    tenant={tenant}
                    colorMode={colorMode ? colorMode : 'light'}
                    color='#A09C8A'
                    difference={
                      percPar && percBev
                        ? (seats / 100) * (percPar - percBev)
                        : undefined
                    }
                    percBev={percBev}
                    percPar={percPar}
                    percDiff={percPar - percBev}
                    seats={seats}
                  />
                )}
              </>
            )
          })}
      </ComparisonWrapper>
      <Divider />
    </Comp>
  )
}

const Personalized = styled.div`
  span {
    padding: 0.25rem 0.5rem;
    display: inline-block;
    background-color: var(--selected-background);
  }
  max-width: 400px;
  margin: 0 auto 3rem;
  @media only screen and (max-width: 600px) {
    margin-top: -10px;
  }
  text-align: center;
  font-size: 1.5rem;
  line-height: 2.2rem;
`
const Comp = styled.div`
  position: relative;
`

const ComparisonWrapper = styled.div`
  max-width: 400px;
  @media only screen and (max-width: 600px) {
    padding: 0 1rem;
  }
  margin: 0 auto 3rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2rem;

  .head {
    text-align: center;
    img {
      width: 36%;
      height: auto;
    }
    h4 {
      margin: -15px auto 1rem;
      text-transform: uppercase;
      color: var(--beige-main);
      font-size: 1.1rem;
    }
    .nomarg {
      margin-bottom: 0;
    }
    .details {
      font-size: 1.1rem;
      line-height: 1.4rem;
      color: var(--gray-3);
      width: 70%;
      margin: 0 auto;
      span {
        white-space: nowrap;
      }
    }
  }
`

const Divider = styled.div`
  background-color: var(--divider-color);
  width: 1px;
  position: absolute;
  top: 60px;
  bottom: 10px;
  left: 50%;
  z-index: -1;
`

export default Comparison
